import { createApiConstants } from '@saucelabs/sl-util-redux/lib/constantHelpers';

import { NAMESPACE } from '../../constants';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);
export const ADD_TO_CANCEL_SUBSCRIPTION = `${NAMESPACE}/ADD_TO_CANCEL_SUBSCRIPTION`;
export const CANCEL_SUBSCRIPTION = createApiNamespacedConstants('CANCEL_SUBSCRIPTION');
